import { Trans } from "@lingui/macro";
import { Button } from "@ster/ster-toolkit";
import { useState } from "react";

import AdvertiserRegistrationModal from "../advertisers/AdvertiserRegistrationModal";

const NewAdvertiserButton = () => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <Button mode="secondary" onClick={() => setOpen(true)}>
        <Trans>Nieuwe adverteerder</Trans>
      </Button>
      {open && (
        <AdvertiserRegistrationModal open onFinish={() => setOpen(false)} />
      )}
    </>
  );
};

export default NewAdvertiserButton;
